var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconExploreEvBig(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Level_Icons",
    "data-name": "Level Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 75.884,
    height: 75.884,
    viewBox: "0 0 75.884 75.884",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#62d6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007091"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5689",
    "data-name": "Path 5689",
    d: "M37.942,0A37.942,37.942,0,1,1,0,37.942,37.942,37.942,0,0,1,37.942,0Z",
    transform: "translate(0)",
    fill: "url(#linear-gradient)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(16.245 21.498)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5990",
    "data-name": "Path 5990",
    d: "M42.61,2.41a.8.8,0,0,0-.8.81V28.91a72.231,72.231,0,0,0-15.76,1,31.49,31.49,0,0,1,13.34-2.58.8.8,0,0,0,.81-.8V.8a.8.8,0,0,0-.81-.8C32.37,0,27,1.41,21.71,4.69,16.37,1.41,11.05,0,4,0a.8.8,0,0,0-.8.8V26.53a.8.8,0,0,0,.8.8,31.46,31.46,0,0,1,13.34,2.58,72.14,72.14,0,0,0-15.75-1V3.22A.81.81,0,1,0,0,3.22V29.75a.79.79,0,0,0,.25.58.83.83,0,0,0,.6.22c.14,0,14.33-.76,20.5,2.33h.16a.64.64,0,0,0,.2,0h.36c6.16-3.09,20.35-2.34,20.49-2.33a.83.83,0,0,0,.6-.22.79.79,0,0,0,.25-.58V3.22a.8.8,0,0,0-.8-.81Zm-4,23.32a31.32,31.32,0,0,0-16.08,4.2V6.07A29.83,29.83,0,0,1,38.59,1.61ZM4.82,1.61A29.81,29.81,0,0,1,20.9,6.07V29.93a31.32,31.32,0,0,0-16.08-4.2Z",
    fill: "#f6f8fa"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExploreEvBig);
export default __webpack_public_path__ + "static/media/icon_explore_ev_big.d26b18d2e32a9f95d4d72c0ac35aee9a.svg";
export { ForwardRef as ReactComponent };